import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";


export const getTaskList = (jobId: any  ,endpoint) => http({
    url: endpoint,
    method: 'get',
    params: {
        jobId: jobId
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});

